document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.ai-senpai__header');

  function checkScroll() {
    if (window.scrollY > 0) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }

  checkScroll();
  window.addEventListener('scroll', checkScroll);
});


document.addEventListener('DOMContentLoaded', function() {

  const targets = document.querySelectorAll('.scroll-fade');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-in');
        observer.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px -200px 0px',
    threshold: 0
  });

  targets.forEach((el) => observer.observe(el));
});


document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.scroll-area').forEach(function(el) {
    new SimpleBar(el, {
      autoHide: false
    });
  });
});
